export function normalizeHttpError(error) {
  const config = error.config || {}
  const response = error.response
  const request = error.request

  const responseTime = config.metadata
    ? Date.now() - config.metadata.startTime
    : null

  const context = {
    method: config.method?.toUpperCase(),
    url: config.url,
    fullURL: config.url
      ? `${config.baseURL || ''}${config.url}`
      : 'unknown',
    responseTime,
    timestamp: new Date().toISOString(),
  }

  // Server responded
  if (response) {
    return {
      ...context,
      category:
        response.status >= 500
          ? 'server_error'
          : 'client_error',

      status: response.status,
      statusText: response.statusText,
      data: response.data,

      message:
        response.data?.message ||
        `HTTP ${response.status} Error`
    }
  }

  // No response
  if (request) {
    return {
      ...context,
      category: 'network_error',
      message: 'No response from server'
    }
  }

  // Config/setup issue
  return {
    ...context,
    category: 'request_error',
    message:
      error.message ||
      'Request configuration error'
  }
}